import React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import Homepage from './Homepage'
import Path from '../path'
import '../styles/styles.scss'

const App = () => {
    return(
        <BrowserRouter>
            <Switch>
                <Route path={Path.HOME}>
                    <Homepage />
                </Route>
                <Route path="/">
                    <Redirect to={Path.HOME} />
                </Route>
            </Switch>
        </BrowserRouter>
    )
}

export default App;